import * as React from "react";
import {useEffect, useState} from "react";
import {IReduxState} from "reducers";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {
    categoriesOrder,
    handleFormValidation,
    makeCatOrder,
    prefillMarkEmail,
    RequiredFields
} from "loan-application/utils";
import ContainerBox from "myshubhlife-component/container-box";
import {COLOR} from "utils/variables";
import {ApplicationRoute} from "loan-application/application/routes";
import {createApplication, getApplicationFields, saveMessages} from "loan-application/apiCall";
import {setApplicationFields, initCategory, markCategoryComplete, setApplicationIndex} from "loan-application/actions";
import {IApplicationFields, ICompletedCategory, ILoanApplicationInputField} from "loan-application/interface";
import Button from "myshubhlife-component/button";
import Modal from "components/Modal";
import {AndroidApis} from "app";
import {imageBaseUrl} from "config";
import Loading from "components/loading";
import {IDocument, IProfile} from "StateInterface";
import {DOC_TYPE} from "loan-application/application/doc-upload/utils";
import {logFirebaseEvent, firebaseEvents} from "firebase/firebaseUtils";
import {exitWebview} from "utils/android";

interface IConnectProps {
    dispatch?: (action: any) => void;
    applicationFields: IApplicationFields;
    fieldsKey: string[];
    selectedLoanProduct: string;
    userId: any;
    isAndroid: boolean;
    completedCategory: ICompletedCategory[];
    profile: IProfile;
    authExt: AuthExt;
    userEmail: string;
    documents: IDocument[];
    apiVersion: number;
}

interface AuthExt {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  emp_id?: string | number;
  phone?: string | number;
}

interface IMessagesAccess {
    type: string;
    value: string;
}

enum RESPONSE_TYPE {
    SUCCESS = "success",
    ERROR = "error",
}

export const SmsPermissionImg = [
    `${imageBaseUrl}/img/sms-permission-accept.webp`,
    `${imageBaseUrl}/img/sms-permission-denied.webp`,
];

const defaultError = "You can not apply for a loan at this moment. Please try again later!"
function Application(props: IConnectProps & RouteComponentProps) {
    const [currentPath] = useState(props.location.pathname);
    const [applyLoanPopup , updateApplyLoanPopup] = useState({type: "", msg: "", show: false});
    const [isLoanDisabled, setIsLoanDisabled] = useState(true);
    const [loader, setLoader] = useState({active: false, msg: ""});
    const [initiateApply, setInitiateApply] = useState(false);
    const [timerId, setTimerId] = useState(null);
    const [showSmsPermissionInfo, setShowSmsPermissionInfo] = useState(false);
    const [smsPermissionImgIndex, setSmsPermissionImgIndex] = useState<number>(0);
    const firebaseEvent = async (eventName: string, eventParams?: {[key: string]: any}) => 
    await logFirebaseEvent(props.apiVersion, eventName, eventParams);

    (window as any).notifyToWeb = async (data: IMessagesAccess) => {
        if (data.type === "SMS") {
            setIsLoanDisabled(true);
            if (data.value) {
                try {
                    await saveMessages(props.userId, data.type, data.value);
                } catch (err) {
                    setIsLoanDisabled(false);
                }
            }
            setInitiateApply(true);
        }
        if (data.type === "CHECK_PERMISSION") {
            data.value ?
            AndroidApis.notifyAndroid("ASK_REQUIRED_DATA_CONFIG", {uploadType: "SMS"}) : setShowSmsPermissionInfo(true);
        }
    };

    useEffect(() => {
        if (initiateApply) {
            pushToApplication();
        }
    }, [initiateApply]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.isAndroid) {
            AndroidApis.toolBarConfig({visibility: true, title: "Profile"});
        }
        if (!props.applicationFields) {
            setLoader({active: true, msg: "Please wait.."});
            getApplicationFields(props.selectedLoanProduct, props.userId).then((res) => {
                setLoader({active: false, msg: ""});
                props.dispatch(setApplicationFields(makeCatOrder(categoriesOrder, res.data)));
                const requiredFields = makeCatOrder(categoriesOrder, res.data)["required_fields"];
                const newCategory = Object.keys(requiredFields);
                props.dispatch(initCategory(newCategory.map(key => ({ categoryName: key, isCategoryCompleted: false }))));
                for (let i = 0; i < newCategory.length; i++) {
                  const categoryFieldInput = Object.keys(requiredFields[newCategory[i]]).map(value => getFieldsForUserInput(
                    requiredFields[newCategory[i]][value]
                  ));
                  for (let j in categoryFieldInput) {
                    if (categoryFieldInput[j].every(v => v === true) && handleFormValidation({}, requiredFields[newCategory[i]], null, props.profile).status) {
                        props.dispatch(markCategoryComplete(true, i));
                    }  else if (prefillMarkEmail.includes(props.userEmail) &&
                       (newCategory.indexOf(RequiredFields.DOCUMENT_UPLOAD) === i || newCategory.indexOf(RequiredFields.KYC) === i )) {
                        props.dispatch(markCategoryComplete(true, i));
                    } else if (newCategory.indexOf(RequiredFields.DOCUMENT_UPLOAD) === i &&
                        (Object.values(requiredFields[newCategory[i]]).map((doc) => doc[0].identifier).every((item) => props.documents.map((pd) => pd.type).includes(item)))) {
                        props.dispatch(markCategoryComplete(true, i));
                    } else if (newCategory.indexOf(RequiredFields.KYC) === i && props.documents.map((pd) => pd.type).includes(DOC_TYPE.CURRENT_ADDRESS_PROOF)){
                        props.dispatch(markCategoryComplete(true, i));
                    } else {
                        props.dispatch(markCategoryComplete(false, i));
                        break;
                    }
                  }
                }
            }).catch((err) => {
                setLoader({active: false, msg: ""});
            });
        }
    }, []);

    useEffect(() => {
        if ((SmsPermissionImg.length - 1) < smsPermissionImgIndex) {
            setSmsPermissionImgIndex(0);
            setShowSmsPermissionInfo(false);
        }
    }, [smsPermissionImgIndex]);

    useEffect(() => {
        if (props.completedCategory && props.completedCategory.length) {
            if (props.completedCategory
                .filter((content) => content["isCategoryCompleted"] === true)
                .length === props.completedCategory.length) {
                setIsLoanDisabled(false);
            } else {
                setIsLoanDisabled(true);
            }
        }
    }, [props.completedCategory]);
    function handleProceed(index: number) {
        props.history.push({pathname: `${currentPath}${ApplicationRoute.USER_FORM}`,
            state: {index},
        });
        props.dispatch(setApplicationIndex(index));
    }

    const getFieldsForUserInput = (field: ILoanApplicationInputField[]) => {
        return field.map((inputDetails) => {
            return inputDetails.hasOwnProperty("value") ? inputDetails.hasOwnProperty("value"): false;
        });
    };

    const pushToApplication = () => {
        setLoader({active: true, msg: "Applying for loan"});
        setIsLoanDisabled(true);
        const cin = props.profile && props.profile.workCin;
        const sourcingCode = props.authExt && props.authExt['utm_source'] ? props.authExt['utm_source'].toUpperCase() : null;
        firebaseEvent(firebaseEvents.APPLIED_FOR_LOAN);
        createApplication(props.userId, props.selectedLoanProduct, cin, sourcingCode).then((res) => {
            setLoader({active: false, msg: ""});
            updateApplyLoanPopup({
                type: RESPONSE_TYPE.SUCCESS,
                msg: "Your loan application is complete! Please wait while we process it!",
                show: true,
            });
        }).catch((err) => {
            setIsLoanDisabled(false);
            setLoader({active: false, msg: ""});
            updateApplyLoanPopup({
                type: RESPONSE_TYPE.ERROR,
                msg: err.response ? (err.response.data && err.response.data["error"]) ?
                err.response.data.error : err.response.data["err"] ?
                err.response.data["err"] : err.response.data : defaultError,
                show: true,
            });
        });
    };

    const onApplyClick = () => {
        clearTimeout(timerId);
        const timeOutId = setTimeout(() => {
            if (props.isAndroid && props.apiVersion > 194) {
                if (props.apiVersion > 196) {
                    AndroidApis.notifyAndroid("CHECK_PERMISSION", {permission: "android.permission.READ_SMS"});
                } else {
                    AndroidApis.notifyAndroid("ASK_REQUIRED_DATA_CONFIG", {uploadType: "SMS"});
                }
            } else {
                pushToApplication();
            }
        }, 500);
        setTimerId(timeOutId);
    };

    const renderApplyLoanPopup = () => {
        const onCloseHandler = () => {
            if (props.isAndroid) {
                exitWebview();
                return;
            }
            updateApplyLoanPopup({show: false, msg: "", type: ""});
            props.history.replace({pathname: "/"});
        };
        if (applyLoanPopup.show && props.isAndroid && applyLoanPopup.type === RESPONSE_TYPE.SUCCESS) {
            setTimeout(() => AndroidApis.openRating(true, false), 2000);
        }
        return(
            <Modal
                title={"Loan Application"}
                active = {applyLoanPopup.show}
                cancellable = {true}
                cancelTitle = "Close"
                onClose = {() => onCloseHandler()}
            >
                <div style={{padding: 20}}>
                    {
                        applyLoanPopup && applyLoanPopup.type === RESPONSE_TYPE.SUCCESS ?
                            <p>{applyLoanPopup.msg}</p> :
                            <p className="text-danger">{applyLoanPopup.msg}</p>
                    }
                </div>
            </Modal>
        );
    };
    return (
        <ContainerBox pageTitle={!props.isAndroid ? "Required Fields" : ""} showBackButton={!props.isAndroid}
            backgroundColor={COLOR.LIGHT_BG}
        >
            <Loading active={loader.active} msg={loader.msg}/>
            <div className="shubhlife-card">
                <div className="card-header">
                    <h5 className="header-text">Required Fields</h5>
                </div>
                {
                    props.applicationFields &&
                    Object.keys(props.applicationFields.required_fields).map((fieldTitle, index) => {
                        return (
                            <div className="field" key={index} onClick={() => handleProceed(index)}>
                                <h4 className="title">{fieldTitle}</h4>
                                <div className="card-right">
                                    {props.completedCategory[index] && props.completedCategory[index]['isCategoryCompleted'] ? <span className="tick-icon"> <img src={`${imageBaseUrl}/img/icons/green_tick.png`} alt="tick-icon"/></span> : ''}
                                    <span className="arrow-icon">&#8250;</span>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            {
                props.applicationFields && Object.keys(props.applicationFields.optional_fields).length > 0 &&
                <div className="shubhlife-card">
                    <div className="card-header">
                        <h5>Optional Fields</h5>
                    </div>
                    {
                        Object.keys(props.applicationFields.optional_fields).map((fieldTitle, index) => {
                            return (
                                <div key={index}>
                                    <h4>{fieldTitle}</h4>
                                </div>
                            );
                        })
                    }
                </div>
            }
            <>
                {showSmsPermissionInfo && <div className="sms-modal-container">
                    <Modal active>
                        <div className="sms-popup-container">
                            {SmsPermissionImg?.map((item, index) =>
                                <img
                                    src={item}
                                    key={index}
                                    width="100%"
                                    alt="sms permission"
                                    className={`border rounded-md ${index !== smsPermissionImgIndex ? "hidden" : ""}`}
                                />)
                            }
                            <div
                                color="primaryBlue"
                                onClick={() => {setShowSmsPermissionInfo(false); AndroidApis.notifyAndroid("ASK_REQUIRED_DATA_CONFIG", {uploadType: "SMS"})}}
                                className="allow-button"
                            >
                                I Agree
                            </div>
                            <span className="skip-text" onClick={() => setSmsPermissionImgIndex((prev) =>  ++prev)}>
                                Skip
                            </span>
                        </div>
                    </Modal>
                </div>
                }
            </>
            <div className="apply-loan-button">
                <Button
                    buttonText={"APPLY FOR LOAN"}
                    onClick={onApplyClick}
                    width={"100%"}
                    rounded={true}
                    isDisabled={isLoanDisabled}
                />
            </div>
            {renderApplyLoanPopup()}
        </ContainerBox>

    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        applicationFields: state.loanApplication.applicationFields,
        fieldsKey: state.loanApplication.requiredFieldsKey,
        selectedLoanProduct: state.loanApplication.selectedLoanProduct,
        isAndroid: state.login.isAndroid,
        apiVersion: state.login.apiVersion,
        completedCategory: state.loanApplication.completedCategory,
        profile: state.profileInfo.profile,
        authExt: state.login.authExt,
        userEmail: state.login.auth ? state.login.auth.email : null,
        documents: state.documents.documents,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Application);
